export type AppStat = {
  name: string
  value: any
  updated_date: string
}

export type UserStat = {
  user: {
    account_id: string
    username?: string
    pseudoname?: string
  }
  name: string
  value: any
  updated_date: string
}

export type DateStat = {
  date: string
  name: string
  value: any
  updated_date: string
}

export type UsersCountStat = {
  count_all: number
  count_confirmed: number
  count_active: number
}

export enum ItemsOrder {
  Asc = 'asc',
  Desc = 'desc',
}
